import { useEffect, useState } from 'react';
import { GraphQLError } from '@zoopla/fetch-graphql';
import { NotificationResult } from '../../graphql.generated';
import { getNotifications } from '../getNotifications';

export const useNotifications = (cookie = '') => {
    const [notifications, setNotifications] = useState<
        NotificationResult[] | undefined
    >();
    const [errors, setErrors] = useState<GraphQLError[] | string | undefined>();

    useEffect(() => {
        (async () => {
            try {
                const [data, errors] = await getNotifications({ cookie });
                if (errors) {
                    setErrors(errors);
                }
                setNotifications(data);
            } catch (e) {
                const message =
                    e instanceof Error ? e.message : 'Unknown error';
                setErrors(message);
            }
        })();
    }, [cookie]);

    return [notifications, errors];
};
